import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";
import { NumberPropsTypes } from "../NumberPropsTypes";
import "../SCSS/stylesMobile.css";

function NumberMobileView({
  isPreview,
  questionId,
  surveyAnswers,
  handleChangeInputNumber,
  surveyAnswersInfo,
}: NumberPropsTypes) {
  return (
    <div className="mobile-supplier-view-number-cover">
      <div className="mobile-supplier-view-number-lower-limit-cover">
        <input
          disabled={
            isPreview ||
            surveyAnswersInfo?.surveyStatus ===
              EnumSurveyAnswerStatus?.COMPLETED
          }
          type="number"
          className="limits"
          placeholder="Please enter number"
          onChange={(e) =>
            surveyAnswersInfo?.surveyStatus !==
              EnumSurveyAnswerStatus?.COMPLETED &&
            handleChangeInputNumber!(questionId, e)
          }
          value={surveyAnswers?.[questionId]?.val ?? ""}
        />
        {surveyAnswersInfo.surveyInfo.questionsInfo.questionObj?.[questionId]
          ?.emissionFactor?.enabled && (
          <div className="mobile-supplier-view-number-emission-factor">{`emission factor is ${surveyAnswersInfo?.surveyInfo?.questionsInfo?.questionObj?.[questionId]?.emissionFactor?.value}`}</div>
        )}
      </div>
    </div>
  );
}

export default NumberMobileView;
